import { AxiosError, AxiosResponse } from "axios";

export enum ErrorType {
  Validation = "validation",
  Server = "server",
}

export type ErrorsType = {
  [key: string]: string;
};

export type ErrorDetailsModel = {
  type: ErrorType;
  fields: string[];
  errors: ErrorsType[];
};

export type ErrorContextValue = {
  key: string;
  value: string;
}

export type ErrorContextModel = {
    type: number;
    message: string;
    context: ErrorContextValue[];
}

export type ValidationResult<T> =
 | { ok: true; value: T }
 | { ok: false; error: ErrorDetailsModel };

function isErrorDetailsModel(obj: any): obj is ErrorDetailsModel { 
  return (
    obj &&
    typeof obj === "object" &&
    "type" in obj &&
    "fields" in obj &&
    "errors" in obj
  );
}

// Catches Axios error, if it's validation error, returns it as value, otherwise rethrows
export async function tryAxios<TResult>(promise: Promise<AxiosResponse<TResult>>, onUnexpectedError?: (error: any) => void): Promise<ValidationResult<TResult>> {
  try {
    const response = await promise;
    return ({ ok: true as const, value: response.data });
  } catch (error) {
    if (error instanceof AxiosError) { 
      const errData = error?.response?.data;
      if (isErrorDetailsModel(errData) && errData.type === ErrorType.Validation) {
        return { ok: false as const, error: errData };
      }
    }
    onUnexpectedError?.(error);
    throw error;
  }
}
